import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type BlogFragment = { id: string, pk: number, description: string, name: string, slug: string, subscribed: boolean, isWholesale: boolean, image: { url: string } };

export const BlogFragmentDoc = gql`
    fragment BlogFragment on BlogType {
  id
  pk
  description
  name
  slug
  subscribed
  isWholesale
  image {
    url
  }
}
    `;